export default "__VITE_ASSET__Cpbgp8TP__"